import { authorizedRequest } from 'shared/api/axios';
import { PRINT_FORMS_BASE_URL } from 'shared/api/api';

export const fetchPrintForm = async (id: number, withStamp = false) => {
  const response = await authorizedRequest<void, string>(
    `${PRINT_FORMS_BASE_URL}/contract-appendix/${id}?stamp=${withStamp ? 'true' : ''}`,
    'GET');
  return response;
};
